import React, { useRef, useState } from "react";
import ErrorLabelWithValue from "../ErrorLabelWithValue/ErrorLabelWithValue";
import HintLabel from "../HintLabel/HintLabel";
import Label from "../Label/Label";
import InfoIcon from "../InfoIcon/InfoIcon";
import InputDescription from "../InputDescription/InputDescription";
import PendingFieldConfirmButton from "../PendingFieldConfirmButton/PendingFieldConfirmButton";
import "./select-field.scss";
import { isFocused } from "../../utilities";

const SelectField = (props) => {
  const {
    id,
    label,
    className,
    placeholder,
    choices,
    hintText,
    description,

    value,
    disabled,
    error,
    pending,
    isRequired,
    validations,
    onChange,
    onBlur,
  } = props;
  const [show, setShow] = useState(false);
  const selectFieldRef = useRef(null);

  const handleToggle = () => setShow(!show);
  return (
    <div className="input-field dcrform-select-field">
      <Label className={pending ? "pending-label" : ""}>{label}</Label>
      <div className={`input-field__wrapper ${className}`}>
        <div className="input-field__inner-wrapper">
          <div className="input-field__confirm-wrapper">
            {choices.radio ? (
              <div className={`radio-group radio-group--${choices.radio.toLowerCase()}`}>
                {choices.entries.map(({ label, value: entryValue }) => (
                  <label key={entryValue} className="radio-option">
                    <input
                      type="radio"
                      name={id}
                      disabled={disabled}
                      // eslint-disable-next-line eqeqeq
                      checked={value == entryValue}
                      value={entryValue}
                      onChange={(e) => {
                        onChange(e);
                        onBlur(e);
                      }}
                    />
                    {label}
                  </label>
                ))}
              </div>
            ) : (
              <select
                ref={selectFieldRef}
                className={`input-field__input ${isRequired ? "error-border" : ""}`}
                name={id}
                disabled={disabled}
                value={value !== null ? value : ""}
                required
                onChange={(e) => {
                  onChange(e);
                  onBlur(e);
                }}
              >
                <option value="">{placeholder ? placeholder : ""}</option>
                {choices.entries.map(({ label, value }) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </select>
            )}
            {pending && value && !isFocused(selectFieldRef.current) && (
              <PendingFieldConfirmButton onClick={() => onBlur(value)} />
            )}
          </div>
          {description && <InfoIcon onClick={handleToggle} active={show} />}
        </div>
        <ErrorLabelWithValue
          isRequired={isRequired}
          error={error}
          validations={validations}
        />
        {hintText && <HintLabel>{hintText}</HintLabel>}
        {description && show && <InputDescription>{description}</InputDescription>}
      </div>
    </div>
  );
};

export default SelectField;
